import './Gallery.less';
import React from 'react';
import Spinner from '../../../../../bootstrap/components/spinner/Spinner';
import colors from '../../../../styles/colors';

const GALLERY_FULL = 'full-view';
const GALLERY_GRID = 'grid-view';

export {
    GALLERY_FULL,
    GALLERY_GRID
};

export default class Gallery extends React.Component {

    /**
     *
     * @param {IFileUploadInfo} fileUploadInfo
     * @return {Component}
     */
    getFileView = (fileUploadInfo) => {
        const {renderThumbnail, renderPlaceholder} = this.props;

        return <div className="file-view" aria-label={fileUploadInfo.filename}>
            <div className="thumbnail-wrapper">
                {
                    fileUploadInfo.record !== null
                        ? renderThumbnail(fileUploadInfo.record)
                        : renderPlaceholder(fileUploadInfo.filename, fileUploadInfo.mimeType)
                }
            </div>
            {
                fileUploadInfo.error !== null &&
                <div className="overlay-error">
                    <div className="error">
                        <div className="filename">{fileUploadInfo.filename}</div>
                        <div className="message">{fileUploadInfo.error}</div>
                    </div>
                </div>
            }
            {
                fileUploadInfo.uploading &&
                <div className="overlay-uploading">
                    <div className="indicator">
                        <Spinner color={colors.white}/>
                    </div>
                </div>
            }
        </div>;
    };


    getFullView = () => {
        const {fileUploadInfoList} = this.props;
        return <div className="full-view">
            {this.getFileView(fileUploadInfoList[0])}
        </div>;
    };

    getGridView = () => {
        const {fileUploadInfoList} = this.props;
        return <div className="grid-view">
            <ul>
                {
                    fileUploadInfoList.map((fileUploadInfo, index) => <li key={index}>
                        <div className="aspect-ratio-keeper">
                            {this.getFileView(fileUploadInfo)}
                        </div>
                    </li>)
                }
            </ul>
        </div>;
    };

    getViewByLayout = (layout) => {
        switch (layout) {
            case GALLERY_FULL: return this.getFullView();
            case GALLERY_GRID: return this.getGridView();
        }

        return null;
    };

    render() {
        const {layout, fileUploadInfoList} = this.props;

        return <div className={'gallery' + (fileUploadInfoList.length === 1 ? ' has-one-file' : '')}>
            {this.getViewByLayout(layout)}
        </div>;
    }
}
